import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";

import { Dialog } from "primereact/dialog";
import { format } from "date-fns";

import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { Interview_Process, IRequirementMast } from "../../../models/RequirementMast";
// import { Publish } from "../../pocTransferReq/Publish";
import { Publish } from "../../requirement/Publish";
import { Req } from "../../../shared/Req";


interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    salEffFilter: any,
    salesID?: number,
    resType: number,
    catID?: number,
    branchID?: number,
    recType?: string,
    totalRec?: boolean | null,
}

const popupHeader = (resType: number): string => {
    if (resType === 1) return "Recruiter Wise Requirement Report";
    else if (resType === 2) return "Recruiter Onsite Requirement Report";
    else if (resType === 3) return "Recruiter Hybrid Requirement Report";
    else if (resType === 4) return "Recruiter Remote Requirement Report";
    else if (resType === 5) return "Recruiter Served Requirement Report";
    else if (resType === 6) return "Recruiter UnServed Requirement Report";
    else if (resType === 7) return "Requirement Wise Recruiter Submission Report";
    else return "Report";
}

export const SubTableEfficiencyReport = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ sn: number }>, loading: boolean });
    const [tableData2, setTableData2] = useState({ tableData: [], loading: false } as { tableData: Array<{ sn: number }>, loading: boolean });
    const [reqData, setReqData] = useState<IRequirementMast>();
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    const dt = useRef<any>(null);
    const dt2 = useRef<any>(null);

    const [subTable2, setSubTable2] = useState({ open: false, req_id: 0 } as { open: boolean, req_id: number });
    const hideSubTableDialog2 = () => {
        setSubTable2({ open: false, req_id: 0 });
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };
    const exportCSV2 = () => {
        dt2.current.exportCSV();
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);
    useEffect(() => {
        if (subTable2.open) loadReqData(); loadTableData2();
    }, [subTable2.open]);

    const loadTableData = async () => {
        console.log("props", props);
        setTableData({ tableData: [], loading: true });
        let filterQuery = "";
        if (props.catID)
            filterQuery += `&catID=${props?.catID}`;
        if (props.salesID)
            filterQuery += `&salesID=${props.salesID}`;
        if (props.branchID)
            filterQuery += `&branchID=${props.branchID}`;

        if (props.recType) {
            filterQuery += `&recType=${props?.recType}`;
        }
        if (props.totalRec === true) {
            filterQuery += `&totalRec=${props?.totalRec}`;
        }
        const response = await Fetch("BranchLatencyReport/LatencyServerInnerreport", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    const loadTableData2 = async () => {
        setTableData2({ tableData: [], loading: true });
        const response = await Fetch("Report_Recruiter/reqwise", "GET", null, `req_id=${subTable2.req_id}`, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData2({ tableData: data, loading: false });
        }
    }
    const loadReqData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${subTable2.req_id}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setReqData(data);
        }
    }

    const onHide = () => {
        props.hideDialog();
    }

    const resume = (rowData: { resume: number, req_ID: number }) =>
        <span onClick={() => setSubTable2({ open: true, req_id: rowData.req_ID })}
            className="cursor-pointer text-cyan-700 underline">{rowData.resume}</span>
    const allocateTime = (rowData: { allocateTime: Date }) => {
        let date;
        if (rowData.allocateTime) date = format(new Date(rowData.allocateTime), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const submissionTime = (rowData: { submissionTime: Date }) => {
        let date;
        if (rowData.submissionTime) date = format(new Date(rowData.submissionTime), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const downloadResume = async (path: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${path}`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const consultant_Name = (rowData: { consultant_Name: string, consultant_Resume_Path: string }) => <span onClick={() => downloadResume(rowData.consultant_Resume_Path)}
        className="cursor-pointer text-cyan-700 underline">{rowData.consultant_Name}</span>

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">{popupHeader(props.resType)}</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );
    const header2 = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Report</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV2} />
        </div>
    );

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };

    return (<>
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />

                <Column field="req_ID" header="Req ID" sortable />
                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_Rate" header="Rate" />
                <Column field="req_InterviewProcess" header="InterviewProcess" body={(rowData: any) => rowData.req_InterviewProcess ? Interview_Process[rowData.req_InterviewProcess] : ""} />
                <Column field="resume" header="#Resume" sortable />
                <Column field="eci" header="#ECI" sortable />
                <Column field="po" header="#PO" sortable />
                <Column field="status" header="Status" />
                <Column field="accSub" header="#AccSub" />
                <Column field="rejSub" header="#RejSub" />
                <Column field="latency" header="#Latency" />

            </DataTable>
        </Dialog>
        <Dialog visible={subTable2.open} style={{ width: '80vw' }} header={header2} modal className="p-fluid" onHide={hideSubTableDialog2}>
            {reqData && <Req req={reqData} />}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt2} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData2.tableData}
                loading={tableData2.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req ID" />
                <Column field="user_Name" header="Recruiter" />
                <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} />
                <Column field="allocateTime" header="Allocation Time" body={allocateTime} />
                <Column field="submissionTime" header="Submission Time" body={submissionTime} />
                <Column field="litancy" header="Litancy(Minutes)" />
                <Column field="tip" header="Sub Status" />
            </DataTable>
        </Dialog>
        <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />

    </>
    );
}